import { FeatureFlag } from '@ps/web-core-enums';
import { select, useFeature } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import { StarsLink } from '@ps/web-shared-ui';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { useFormattedSelfExclusionDate } from '@swf/core/utils/selfExclusionDate';
import { Alert, TempAccountLimit } from '@swf/first';

import {
  TXTCLI_Your_account_is_suspended,
  TXTWCL_This_means_you_wonXt_be_able_t_ELL_18,
  TXTWCL_This_means_you_wonXt_be_able_t_ELL_19,
  TXTWCL_Verify_my_account,
  TXTWCL_YouXre_self_excluded,
  TXTWCL_YouXre_taking_a_break
} from './AccountStatusAlert.messages.json';
import styles from './AccountStatusAlert.scss';

const AccountStatusAlert: React.FC = () => {
  const [showVerificationPrompt, setShowVerificationPrompt] = useState(false);
  const amlSuspended = useSelector(select.account.amlSuspended);
  const isSelfExcluded = useSelector(select.account.getSelfExclusion);
  const formattedDate = useFormattedSelfExclusionDate();
  const isSuspendedRM = useSelector(select.account.isSuspendRM);
  const nationalExclusion = useSelector(select.account.bannedByRegulator);
  const isEmbedded = useSelector(select.device.isEmbedded);
  const currentlyTakingBreak = isSelfExcluded || nationalExclusion;
  const verifyDoc = useFeature(FeatureFlag.VerifyDoc);
  let alertContent;

  const openVerificationPrompt = (e: React.MouseEvent) => {
    e.preventDefault();
    isEmbedded && verifyDoc
      ? window.starsweb?.app?.execute('docverify')
      : setShowVerificationPrompt(true);
  };

  switch (true) {
    case isSelfExcluded:
      alertContent = (
        <Alert variant="warning" className={styles.accountStatusAlert}>
          <div className={styles.accountStatusAlertTitle}>
            {currentlyTakingBreak ? (
              <Translation {...TXTWCL_YouXre_taking_a_break} />
            ) : (
              <Translation {...TXTWCL_YouXre_self_excluded} />
            )}
          </div>
          <Translation
            values={{
              0: <span className={styles.accountStatusAlertDate}>{formattedDate}</span>
            }}
            {...TXTWCL_This_means_you_wonXt_be_able_t_ELL_18}
          />
        </Alert>
      );
      break;
    case amlSuspended || isSuspendedRM:
      alertContent = (
        <>
          <Alert variant="error" className={styles.accountStatusAlert}>
            <div className={styles.accountStatusAlertTitle}>
              <Translation {...TXTCLI_Your_account_is_suspended} />
            </div>
            <Translation {...TXTWCL_This_means_you_wonXt_be_able_t_ELL_19} />
            <StarsLink onClick={openVerificationPrompt}>
              <Translation {...TXTWCL_Verify_my_account} />{' '}
            </StarsLink>
          </Alert>
          {showVerificationPrompt && (
            <TempAccountLimit onClose={() => setShowVerificationPrompt(false)} />
          )}
        </>
      );
      break;
    default:
      alertContent = null;
  }

  return alertContent ? <div>{alertContent}</div> : null;
};

export default AccountStatusAlert;
